import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import 'flag-icons/css/flag-icons.min.css'
import { themeStore } from './store/theme'

// Initialize theme on app start
themeStore.init()

createApp(App).use(router).mount('#app')
